export const CK = "ck_b37e5d2c2b254b85266e22e0bb9a8efad58b056a";
export const CS = "cs_5862a99fa95081b4f3a45a6084ef498258995db7";

export const TEN_YEARS = undefined;

export const TOKEN_TYPE = 'Bearer '
export const REQUEST_HEADER_AUTH_KEY = 'Authorization'
